import React, { Component } from 'react';
import classSet from 'react-classset';
import AppBackground from '../AppBackground/AppBackground';

class Modal extends Component {

  constructor() {
    super();
    this.state = {
      showing: false
    }
    this.closeModal = this.closeModal.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
  }

  componentDidMount() {
    const self = this;
    setTimeout( () => {
      self.setState({showing: true});
    }, 50);
    window.addEventListener('keydown', this.handleKeypress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeypress);
  }

  handleKeypress(e) {
    if (e.keyCode === 27 || e.keyCode === 37) {
      this.closeModal();
    }
  }

  closeModal() {
    this.setState({showing: false});
    setTimeout( () => {
      this.props.onClose();
    }, 200);
  }

  render() {

    const childWithProps = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {closeModal: this.closeModal});
    });

    const modalClasses = classSet({
      'ssc__modal': true,
      'ssc__modal--showing': this.state.showing,
      'ssc__modal--fade': this.props.fadeIn,
      'ssc__modal--slide': this.props.slideIn,
      'ssc__modal--with-background': this.props.showBackground
    });

    return (
      <div className={modalClasses} style={this.props.customStyle}>
        {this.props.showBackground &&
          <AppBackground
            appHeight={this.props.appHeight}
          />
        }
        {this.props.closeIcon &&
          <img className="ssc__modal__close" src={this.props.closeIcon} onClick={() => this.closeModal(null)} alt="close" />
        }
        <div className="ssc__modal__inner">
          {childWithProps}  
        </div>
      </div>
    );
  }

}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js